import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'

import { DevIndicator } from '@/shared/ui/DevIndicator'
import { DevTitlePrefix } from '@/shared/ui/DevTitlePrefix'
import { AppProviders } from '@/shared/providers/AppProviders'

export const Route = createRootRoute({
  head: () => ({
    meta: [{ title: buildPageTitle() }]
  }),
  component: RootLayout
})

function RootLayout() {
  return (
    <AppProviders>
      <HeadContent />
      <div className="antialiased">
        <Outlet />
        {import.meta.env.DEV && (
          <>
            <DevTitlePrefix />
            <DevIndicator />
          </>
        )}
      </div>
    </AppProviders>
  )
}
